import EmbedOpinary from '@/components/embeds/EmbedOpinary/EmbedOpinary'
import { type StorylineOpinaryModelType } from '@/types/cms/Storylines'
import styles from './StorylineOpinary.module.scss'

export default function StorylineOpinary({ item }: { readonly item: { model: StorylineOpinaryModelType } }) {
  return (
    <div className={styles.wrapper}>
      <EmbedOpinary opinaryId={item.model.fields['opinary-id'].value} />
    </div>
  )
}
